import React from 'react';
import { getPressArticles, queryPageData } from 'lib/dato-request';
import { FeaturedPress } from 'components/Press/FeaturedPress';
import { Hero } from 'components/Press/Hero';
import { PressListing } from 'components/Press/PressListing';
import { Trustbar2 } from 'components/Trustbar2';
import SecondaryPageLayout from '@/components/ReusableUI/SecondaryPageLayout';

const Press = ({ data, articles }) => {
    const { page } = data;
    const { components, seo } = page;
    const featuredArticle = articles.allPressArticles.find(
        article => article.featured
    );
    return (
        <SecondaryPageLayout page={page} components={[components[2], components[3]]}>
            <Hero
                heading={components[0].heading}
                subhead={components[0].subhead}
                img={components[0].featuredImage || '/assets/graphics/press-hero.png'}
            />
            <Trustbar2 id='press-trustbar' logos={components[1].gallery} bgColor='#ffffff' className='mt-10' />
            {featuredArticle && <FeaturedPress article={featuredArticle} />}
            <PressListing articles={articles} />
        </SecondaryPageLayout>
    );
};

export async function getStaticProps() {
    const data = await queryPageData('Press');
    const articles = await getPressArticles();
    return {
        props: { data, articles }
    };
}

export default Press;
